<template>
	<div class="helptableFormHeader puiformheader">
	</div>
</template>

<script>
import PuiFormHeaderMixin from '@Pui9Mixins/PuiFormHeaderMixin';

export default {
	name: 'helptable-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'helptable'
		};
	},
	computed: {
	}
}
</script>
